module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('p', {
    staticClass: "DEDF"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("TO THE MEMORY OF MABEL T. BELCHER.")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The greatest mother, father, friend, and supporter a man could ever ask for. This one is for you, Mom. They are all for, and because of, you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0